import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'SourceChannel/', method: 'POST', body: body, token: token })
}
